import React, { useState } from 'react';
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Shield, User, BarChart3 } from 'lucide-react';
import ProfileSettings from './components/ProfileSettings';
import SecuritySettings from './components/SecuritySettings';
import GoogleAnalyticsSettings from './components/GoogleAnalyticsSettings';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('analytics');

  const settingsTabs = [
    {
      id: 'analytics',
      label: 'Analytics',
      icon: BarChart3,
      description: 'Connect and manage Google Analytics',
      component: <GoogleAnalyticsSettings />,
      disabled: false
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      description: 'Manage your account information',
      component: <ProfileSettings />,
      disabled: false
    },
    {
      id: 'security',
      label: 'Security',
      icon: Shield,
      description: 'Password and security settings',
      component: <SecuritySettings />,
      disabled: false
    },
    // {
    //   id: 'notifications',
    //   label: 'Notifications',
    //   icon: Bell,
    //   description: 'Email and push notification preferences',
    //   component: <NotificationSettings />,
    //   disabled: true
    // },
    // {
    //   id: 'appearance',
    //   label: 'Appearance',
    //   icon: Palette,
    //   description: 'Theme and display preferences',
    //   component: <AppearanceSettings />,
    //   disabled: true
    // },
    // {
    //   id: 'data',
    //   label: 'Data & Privacy',
    //   icon: Database,
    //   description: 'Data export and privacy settings',
    //   component: <DataSettings />,
    //   disabled: true
    // }
  ];

  const handleTabChange = (value: string) => {
    const tab = settingsTabs.find(t => t.id === value);
    if (tab && !tab.disabled) {
      setActiveTab(value);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Manage your account settings and preferences
        </p>
      </div>

      {/* Settings Tabs */}
      <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 lg:grid-cols-6">
          {settingsTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <TabsTrigger 
                key={tab.id} 
                value={tab.id}
                className={`flex items-center space-x-2 ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                <Icon className="h-4 w-4" />
                <span className="hidden sm:inline">{tab.label}</span>
              </TabsTrigger>
            );
          })}
        </TabsList>

        {settingsTabs.map((tab) => (
          <TabsContent key={tab.id} value={tab.id} className="space-y-6">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <tab.icon className="h-5 w-5 text-primary" />
                <h2 className="text-2xl font-semibold tracking-tight">{tab.label}</h2>
              </div>
              <p className="text-muted-foreground mb-6">{tab.description}</p>
              {tab.component}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default Settings;
